








































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AppSwitch from '@/views/kyc-form/component/AppSwitch.vue'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import highRiskCountryList from '@company-common/config/high-risk-country.json'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppSwitch,
    AppRadioSelection
  }
})
export default class AML extends Vue {
  selectedClient = 'Client 1';

  private highRiskCountryList = highRiskCountryList

  @kycFormStore.State
  private kycForm!: KYCForm;

  private ratingTable = [
    {
      rating: 'LOW<br> Other LOW Risk<br> categories - Section A.(i)',
      desc: 'Simplified CDD Account can be opened once information / documents mentioned in section A have been provided. On-Going Monitoring Customer profile updated once in 2 years.'
    },
    {
      rating: 'MEDIUM',
      desc: 'Normal CDD Greater care required and documents listed in Section A should be obtained before opening of account. On-Going Monitoring Customer profile updated once in 1 year.'
    },
    {
      rating: 'HIGH',
      desc: 'Enhanced CDD Account can be opened once information / documents mentioned in section A have been provided. On-Going Monitoring Transactions shall be monitored to ensure that the funds used for investments are from an account under the Customer’s own name in a financial institution (e.g. bank) subject to high due diligence standards and the amount and frequency of transactions are within his/her expected economic means.'
    },
    {
      rating: 'HIGH/STR',
      desc: 'Rejected Unable to conduct CDD. Customer appears on sanctions list. Customer screening returns adverse results. STR: Customer is reluctant to unable, unwilling, or reluctant to provide information requested, and decides to withdraw application. Customer behaviour triggers several Red Flags.'
    }
  ]

  clientOptionSelected (option: string): void {
    if (option === 'Client 2' && !this.isClient2Included()) {
      window.alert(
        'Client 2 is not included in this KYC Form. To include, go to "Client Summary" page and enable the checkbox.'
      )
      return
    }
    this.selectedClient = option
  }

  isClient2Included () {
    return this.kycForm.client2.personalDetails.included
  }

  get editingClient () {
    if (this.selectedClient === 'Client 1') {
      return {
        aml: this.kycForm.client1.aml,
        personalDetails: this.kycForm.client1.personalDetails
      }
    } else {
      return {
        aml: this.kycForm.client2.aml,
        personalDetails: this.kycForm.client2.personalDetails
      }
    }
  }

  get isSingaporean () {
    return this.editingClient.aml.isSingaporean
  }

  get isHighRiskPR () {
    return this.editingClient.aml.isHighRiskPR
  }

  get isHighRiskForeign () {
    return this.editingClient.aml.isHighRiskForeign
  }

  get transactValue () {
    const clientIndex = parseInt(this.selectedClient.substring(this.selectedClient.length - 1))
    return this.kycForm.recommendations['c' + clientIndex + 'TransactValue']
  }

  get overallRiskRating () {
    if (this.selectedClient === 'Client 1') {
      return this.kycForm.client1.aml.riskRating
    } else return this.kycForm.client2.aml.riskRating
  }

  updateTransactValChecking () {
    return this.editingClient.aml.transactValueBelowThreshold
  }

  mounted () {
    this.updateTransactValChecking()
  }

  @Watch('transactValue')
  upTV () {
    this.updateTransactValChecking()
  }

  @Watch('selectedClient')
  upTV2 () {
    this.updateTransactValChecking()
  }
}
